var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { SpaceCooperationRepository } from '../repository/space-cooperation-repository.interface';
let SpaceCooperationServiceImpl = class SpaceCooperationServiceImpl {
    constructor(_spaceCooperationRepository) {
        this._spaceCooperationRepository = _spaceCooperationRepository;
    }
    getSpaceCooperation(spaceId) {
        return this._spaceCooperationRepository.getSpaceCooperation(spaceId);
    }
};
SpaceCooperationServiceImpl = __decorate([
    injectable(),
    __param(0, inject(SpaceCooperationRepository)),
    __metadata("design:paramtypes", [typeof (_a = typeof SpaceCooperationRepository !== "undefined" && SpaceCooperationRepository) === "function" ? _a : Object])
], SpaceCooperationServiceImpl);
export { SpaceCooperationServiceImpl };
